module.exports = __webpack_public_path__ + "static/media/addresses_restantes.3b3dbdd6.svg";